import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
interface Clientes {
  value: number;
  name: string;
}
interface Establecimientos {
  establecimientoId: number;
  clienteId: number;
  name: string;
}
@Component({
  selector: 'app-agregar-usuario',
  templateUrl: './agregar-usuario.component.html',
  styleUrls: ['./agregar-usuario.component.css']
})
export class AgregarUsuarioComponent implements OnInit, OnDestroy {

  tipoUsuario: number = 2;
  tipoUsuarioRecuperacion: number = 4;
  estado: number = 1;
  errorName: boolean = false;
  errorEmail: boolean = false;
  errorEmailNoti: boolean = false;
  errorContrasenha: boolean = false;
  errorContrasenhaMinlength: boolean = false;
  errorContrasenhaIguales: boolean = false;
  usuarioCreado: boolean = false;
  errorFinal: boolean = false;
  errorFinalMessage: string = "";
  clientsData: any = [];
  tiempoEsperaRecarga: number = 60000;
  errorMessage: string = "";
  showClienteError: boolean = false;
  waitAfterSave: boolean = false;
  es_estrella: boolean = false;

  //ESTABLECIMIENTOS
  establecimientos: Establecimientos[] = [];
  establecimientosCopia: Establecimientos[] = [];
  selectAllEstablecimientos: boolean = false;
  selectedEstablecimiento: number[] = [];
  //AUTOCOMPLETE
  myControl = new FormControl<string | Establecimientos>('');
  filteredOptions!: Observable<Establecimientos[]>;

  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.email, Validators.required]),
    emailNoti: new FormControl('', [Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(4)]),
    passwordR: new FormControl('', [Validators.required, Validators.minLength(4)]),
  });

  hide = true;
  hideR = true;
  userData: any = [];
  segmentSelect = "tab-userCorporativos";

  private clientsSubscription: Subscription | undefined;
  private agregarUsuarioSubscription: Subscription | undefined;

  constructor(private userService: UserService, private router: Router, private error429: Error429Service,
    private userDataService: UserDataService) {
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    this.es_estrella = this.userData.es_estrella === '1';
    this.clientsSubscription = this.userService.getClients().subscribe({
      next: resp => {
        for (let i = 0; i < resp.length; i++) {
          this.clientsData.push(resp[i]);
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
          if (resp[i].establishments.length !== 0) {
            for (let j = 0; j < resp[i].establishments.length; j++) {
              this.establecimientos.push({
                establecimientoId: resp[i].establishments[j].id,
                clienteId: resp[i].establishments[j].est_cliente_id,
                name: resp[i].establishments[j].est_name
              });
            }
          }
        }
        if (this.clientes.length === 1) {
          this.selectedCliente = this.clientes[0].value;
        }
        this.establecimientosCopia = this.establecimientos;
        /*this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const name = typeof value === 'string' ? value : value?.name;
            return name ? this._filter(name as string) : this.establecimientosCopia.slice();
          }),
        );*/
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => { }
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    }
    if (this.agregarUsuarioSubscription) {
      this.agregarUsuarioSubscription.unsubscribe();
    }
  }

  clienteSeleccionado() {
    //this.limpiarSeleccion();
    this.selectedEstablecimiento = [];
    const establecimientosFiltrados = this.establecimientos.filter(est => est.clienteId === this.selectedCliente);
    this.establecimientosCopia = establecimientosFiltrados;
    /*this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.establecimientosCopia.slice();
      }),
    );*/
  }

  //AUTOCOMPLETE ESTABLECIMIENTOS
  /*private _filter(name: string): Establecimientos[] {
    const filterValue = name.toLowerCase();

    return this.establecimientosCopia.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(establecimiento: Establecimientos): string {
    return establecimiento && establecimiento.name ? establecimiento.name : '';
  }
 
  limpiarSeleccion(): void {
    this.myControl.setValue('');
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.establecimientosCopia.slice();
      }),
    );
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
    console.log(selectedDispositivo);
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
    }
  }*/

  selectAllEstablecimientosChanged() {
    if (this.selectAllEstablecimientos) {
      this.selectedEstablecimiento = this.establecimientosCopia.map(establecimiento => establecimiento.establecimientoId);
    } else {
      this.selectedEstablecimiento = [];
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  get nameInput() {
    return this.signin.get('name');
  }
  get surnameInput() {
    return this.signin.get('surname');
  }
  get emailInput() {
    return this.signin.get('email');
  }
  get emailNotiInput() {
    return this.signin.get('emailNoti');
  }
  get passwordInput() {
    return this.signin.get('password');
  }
  get passwordRInput() {
    return this.signin.get('passwordR');
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.textLabel === 'USUARIO CORPORATIVOS MS') {
      this.segmentSelect = "tab-userCorporativos";
    } else {
      this.segmentSelect = "tab-userDataBeer";
    }
  }

  guardarUsuario() {

    if (this.es_estrella) {
      if (this.segmentSelect === "tab-userCorporativos") {
        //Errro nombre vacio
        if (this.nameInput?.value == "") {
          this.errorName = true;
        } else {
          this.errorName = false;
        }
        //Error email vacio o no valido
        //No se verifica si el email existe, sino que tenga formato email
        if (this.emailInput?.valid) {
          this.errorEmail = false;
        } else {
          this.errorEmail = true;
        }
        //Error emailNoti vacio o no valido
        //No se verifica si el email existe, sino que tenga formato email
        if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
          this.errorEmailNoti = false;
        } else {
          this.errorEmailNoti = true;
        }
        //Error Cliente seleccionado
        if (this.selectedCliente === undefined) {
          this.showClienteError = true;
        } else {
          this.showClienteError = false;
        }
        //Establecimiento solo cuando es hostelero
        //const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
        if (this.tipoUsuario == 2) {
        } else {
          //Si el usuario no es hostelero se limpia el establecimiento
          this.selectedEstablecimiento = [];
        }
        //Comprobar que no haya ningún error y crear el usaurio
        if (this.errorName == false && this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenhaMinlength == false
          && this.errorContrasenha == false && this.errorContrasenhaIguales == false && this.showClienteError == false) {

          let user = {
            _method: "PUT",
            email: this.emailInput?.value,
            is_corporative: true,
            user_mail: this.emailNotiInput?.value,
            user_fullname: this.nameInput?.value,
            pro_id: this.tipoUsuario,
            cliente_id: this.selectedCliente,
            user_status: this.estado,
            acl_establishments: JSON.stringify(this.selectedEstablecimiento)
          };
          this.agregarUsuarioSubscription = this.userService.createUser(user).subscribe({
            next: resp => {
              // console.log(resp);
            }, error: err => {
              // console.log(err);
              this.errorFinalMessage = err.error.message;
              const errorFields = err.error?.error;

              if (errorFields) {
                this.errorFinalMessage = Object.keys(errorFields)
                  .map(field => errorFields[field].join(', '))
                  .join(' | ');
              } else {
                this.errorFinalMessage = err.message || 'Error desconocido';
              }
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.errorFinal = true;
                setTimeout(() => {
                  this.errorFinal = false;
                  this.waitAfterSave = false;
                }, 3500)
              }
              //console.log(err.statusText);
            }, complete: () => {
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.usuarioCreado = true;
                setTimeout(() => {
                  //Vaciar los valores de los inputs para que 
                  this.signin.setValue({
                    name: '',
                    email: '',
                    emailNoti: '',
                    password: '',
                    passwordR: '',
                  });
                  this.tipoUsuario = 2;
                  this.selectedCliente = undefined;
                  this.estado = 1;
                  this.selectedEstablecimiento = [];
                  this.waitAfterSave = false;
                  this.usuarioCreado = false;
                }, 3500);
              }
            }
          })
        }

        /*console.log("Nombre: ", this.nameInput?.value);
        console.log("Correo electrónico: ", this.emailInput?.value);
        console.log("Contraseña: ", this.passwordInput?.value);
        console.log("Contraseña Repetida: ", this.passwordRInput?.value);
        console.log('El cliente seleccionado es: ', this.selectedCliente);
        console.log("Tipo de Usuario: ", this.tipoUsuario);
        console.log("Estado: ", this.estado);
    
        console.log('---------------------------------------');*/
      } else {
        //Errro nombre vacio
        if (this.nameInput?.value == "") {
          this.errorName = true;
        } else {
          this.errorName = false;
        }
        //Error email vacio o no valido
        //No se verifica si el email existe, sino que tenga formato email
        if (this.emailInput?.valid) {
          this.errorEmail = false;
        } else {
          this.errorEmail = true;
        }
        //Error emailNoti vacio o no valido
        //No se verifica si el email existe, sino que tenga formato email
        if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
          this.errorEmailNoti = false;
        } else {
          this.errorEmailNoti = true;
        }
        //Error no hay contraseña
        const passwordVal = this.passwordInput?.value;
        if (!passwordVal) {
          this.errorContrasenha = true;
        } else if (passwordVal.length < 4) {
          this.errorContrasenha = false;
          this.errorContrasenhaMinlength = true;
        } else {
          this.errorContrasenha = false;
          this.errorContrasenhaMinlength = false;
        }
        //Error contraseña iguales
        if (this.passwordInput?.value === this.passwordRInput?.value) {
          this.errorContrasenhaIguales = false;
        } else {
          this.errorContrasenhaIguales = true;
        }
        //Error Cliente seleccionado
        if (this.selectedCliente === undefined) {
          this.showClienteError = true;
        } else {
          this.showClienteError = false;
        }
        
        //Comprobar que no haya ningún error y crear el usaurio
        if (this.errorName == false && this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenhaMinlength == false
          && this.errorContrasenha == false && this.errorContrasenhaIguales == false && this.showClienteError == false) {

          let user = {
            _method: "PUT",
            email: this.emailInput?.value,
            user_pass1: this.passwordInput?.value,
            user_pass2: this.passwordRInput?.value,
            user_mail: this.emailNotiInput?.value,
            user_fullname: this.nameInput?.value,
            pro_id: this.tipoUsuarioRecuperacion,
            cliente_id: this.selectedCliente,
            user_status: this.estado,
            acl_establishments: JSON.stringify([])
          };
          this.agregarUsuarioSubscription = this.userService.createUser(user).subscribe({
            next: resp => {
              // console.log(resp);
            }, error: err => {
              // console.log(err);
              this.errorFinalMessage = err.error.message;
              const errorFields = err.error?.error;

              if (errorFields) {
                this.errorFinalMessage = Object.keys(errorFields)
                  .map(field => errorFields[field].join(', '))
                  .join(' | ');
              } else {
                this.errorFinalMessage = err.message || 'Error desconocido';
              }
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.errorFinal = true;
                setTimeout(() => {
                  this.errorFinal = false;
                  this.waitAfterSave = false;
                }, 3500)
              }
              //console.log(err.statusText);
            }, complete: () => {
              if (!this.waitAfterSave) {
                this.waitAfterSave = true;
                this.usuarioCreado = true;
                setTimeout(() => {
                  //Vaciar los valores de los inputs para que 
                  this.signin.setValue({
                    name: '',
                    email: '',
                    emailNoti: '',
                    password: '',
                    passwordR: '',
                  });
                  this.selectedCliente = undefined;
                  this.estado = 1;
                  this.selectedEstablecimiento = [];
                  this.waitAfterSave = false;
                  this.usuarioCreado = false;
                }, 3500);
              }
            }
          })
        }

        /*console.log("Nombre: ", this.nameInput?.value);
        console.log("Correo electrónico: ", this.emailInput?.value);
        console.log("Contraseña: ", this.passwordInput?.value);
        console.log("Contraseña Repetida: ", this.passwordRInput?.value);
        console.log('El cliente seleccionado es: ', this.selectedCliente);
        console.log("Tipo de Usuario: ", this.tipoUsuario);
        console.log("Estado: ", this.estado);
    
        console.log('---------------------------------------');*/
      }
    } else {
      //Errro nombre vacio
      if (this.nameInput?.value == "") {
        this.errorName = true;
      } else {
        this.errorName = false;
      }
      //Error email vacio o no valido
      //No se verifica si el email existe, sino que tenga formato email
      if (this.emailInput?.valid) {
        this.errorEmail = false;
      } else {
        this.errorEmail = true;
      }
      //Error emailNoti vacio o no valido
      //No se verifica si el email existe, sino que tenga formato email
      if (this.emailNotiInput?.value === '' || this.emailNotiInput?.valid) {
        this.errorEmailNoti = false;
      } else {
        this.errorEmailNoti = true;
      }
      //Error no hay contraseña
      const passwordVal = this.passwordInput?.value;
      if (!passwordVal) {
        this.errorContrasenha = true;
      } else if (passwordVal.length < 4) {
        this.errorContrasenha = false;
        this.errorContrasenhaMinlength = true;
      } else {
        this.errorContrasenha = false;
        this.errorContrasenhaMinlength = false;
      }
      //Error contraseña iguales
      if (this.passwordInput?.value === this.passwordRInput?.value) {
        this.errorContrasenhaIguales = false;
      } else {
        this.errorContrasenhaIguales = true;
      }
      //Error Cliente seleccionado
      if (this.selectedCliente === undefined) {
        this.showClienteError = true;
      } else {
        this.showClienteError = false;
      }
      //Establecimiento solo cuando es hostelero
      //const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
      if (this.tipoUsuario == 2) {
      } else {
        //Si el usuario no es hostelero se limpia el establecimiento
        this.selectedEstablecimiento = [];
      }
      //Comprobar que no haya ningún error y crear el usaurio
      if (this.errorName == false && this.errorEmail == false && this.errorEmailNoti == false && this.errorContrasenhaMinlength == false
        && this.errorContrasenha == false && this.errorContrasenhaIguales == false && this.showClienteError == false) {

        let user = {
          _method: "PUT",
          email: this.emailInput?.value,
          user_pass1: this.passwordInput?.value,
          user_pass2: this.passwordRInput?.value,
          user_mail: this.emailNotiInput?.value,
          user_fullname: this.nameInput?.value,
          pro_id: this.tipoUsuario,
          cliente_id: this.selectedCliente,
          user_status: this.estado,
          acl_establishments: JSON.stringify(this.selectedEstablecimiento)
        };
        this.agregarUsuarioSubscription = this.userService.createUser(user).subscribe({
          next: resp => {
            // console.log(resp);
          }, error: err => {
            // console.log(err);
            this.errorFinalMessage = err.error.message;
            const errorFields = err.error?.error;

            if (errorFields) {
              this.errorFinalMessage = Object.keys(errorFields)
                .map(field => errorFields[field].join(', '))
                .join(' | ');
            } else {
              this.errorFinalMessage = err.message || 'Error desconocido';
            }
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
              this.errorFinal = true;
              setTimeout(() => {
                this.errorFinal = false;
                this.waitAfterSave = false;
              }, 3500)
            }
            //console.log(err.statusText);
          }, complete: () => {
            if (!this.waitAfterSave) {
              this.waitAfterSave = true;
              this.usuarioCreado = true;
              setTimeout(() => {
                //Vaciar los valores de los inputs para que 
                this.signin.setValue({
                  name: '',
                  email: '',
                  emailNoti: '',
                  password: '',
                  passwordR: '',
                });
                this.tipoUsuario = 2;
                this.selectedCliente = undefined;
                this.estado = 1;
                this.selectedEstablecimiento = [];
                this.waitAfterSave = false;
                this.usuarioCreado = false;
              }, 3500);
            }
          }
        })
      }

      /*console.log("Nombre: ", this.nameInput?.value);
      console.log("Correo electrónico: ", this.emailInput?.value);
      console.log("Contraseña: ", this.passwordInput?.value);
      console.log("Contraseña Repetida: ", this.passwordRInput?.value);
      console.log('El cliente seleccionado es: ', this.selectedCliente);
      console.log("Tipo de Usuario: ", this.tipoUsuario);
      console.log("Estado: ", this.estado);
  
      console.log('---------------------------------------');*/
    }
  }
}
